import React from 'react';

const Icon = ({ name, size, className }) => {
  return (
    <svg className={className} width={size} height={size}>
      <use href={'/ui/images/tabler-icons/' + name + '.svg#' + name}></use>
    </svg>
  );
};

export default Icon;
